// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/copyright.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background-color: #111720;
}
.footer-dividline {
    width: 7.29167rem;
    height: 0.00521rem;
    background-color: #6F7783;
    opacity: .3;
    margin: 0 auto;
}
.footer-content {
    color: #6F7783;
    font-size: 0.07292rem;
    text-align: center;
    margin-top: 0.15625rem;
    padding-bottom: 0.15625rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.footer-content-dividline {
    width: 0.00521rem;
    height: 0.07813rem;
    background-color: #6F7783;
    display: inline-block;
    margin-left: 0.05208rem;
}
.footer-content-copyright {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 0.10417rem;
    height: 0.10417rem;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    margin: 0 0.05208rem;
} 
.footer-content-copyright-link {
    color: #2475EE;
    cursor: pointer;
}

@media screen and (max-width: 700px) {
    .footer {
        padding: 0.15625rem 0;
    }
    .footer-content {
         font-size: 0.22917rem;
    }
    .footer-dividline {
        width: 9.375rem;
    }
    .footer-content-copyright-content {
        width: 100%;
        margin-bottom: 0.10417rem;
        padding: 0 0.26042rem;
    }
    .footer-content-dividline {
        display: none;
    }
    .footer-content-copyright {
        width: 0.20833rem;
        height: 0.20833rem;
    }
   
}
@media screen and (max-width: 340px) {
    .footer-content {
         font-size: 0.1875rem;
    }
    .footer-content-copyright-content {
        padding: 0 0.26042rem;
    }
    .footer-content-copyright {
        width: 0.3125rem;
        height: 0.3125rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;IACI,iBAAa;IACb,kBAAW;IACX,yBAAyB;IACzB,WAAW;IACX,cAAgB;AACpB;AACA;IACI,cAAc;IACd,qBAAe;IACf,kBAAkB;IAClB,sBAAgB;IAChB,0BAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,iBAAU;IACV,kBAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,uBAAiB;AACrB;AACA;IACI,yDAA0D;IAC1D,iBAAW;IACX,kBAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,qBAAqB;IACrB,oBAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,qBAAiB;IACrB;IACA;SACK,qBAAe;IACpB;IACA;QACI,eAAa;IACjB;IACA;QACI,WAAW;QACX,yBAAmB;QACnB,qBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;QACI,iBAAW;QACX,kBAAY;IAChB;;AAEJ;AACA;IACI;SACK,oBAAe;IACpB;IACA;QACI,qBAAiB;IACrB;IACA;QACI,gBAAW;QACX,iBAAY;IAChB;AACJ","sourcesContent":[".footer {\n    background-color: #111720;\n}\n.footer-dividline {\n    width: 1400px;\n    height: 1px;\n    background-color: #6F7783;\n    opacity: .3;\n    margin: 0px auto;\n}\n.footer-content {\n    color: #6F7783;\n    font-size: 14px;\n    text-align: center;\n    margin-top: 30px;\n    padding-bottom: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n}\n.footer-content-dividline {\n    width: 1px;\n    height: 15px;\n    background-color: #6F7783;\n    display: inline-block;\n    margin-left: 10px;\n}\n.footer-content-copyright {\n    background-image: url('../../assets/images/copyright.svg');\n    width: 20px;\n    height: 20px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: inline-block;\n    margin: 0 10px;\n} \n.footer-content-copyright-link {\n    color: #2475EE;\n    cursor: pointer;\n}\n\n@media screen and (max-width: 700px) {\n    .footer {\n        padding: 30px 0px;\n    }\n    .footer-content {\n         font-size: 44px;\n    }\n    .footer-dividline {\n        width: 1800px;\n    }\n    .footer-content-copyright-content {\n        width: 100%;\n        margin-bottom: 20px;\n        padding: 0px 50px;\n    }\n    .footer-content-dividline {\n        display: none;\n    }\n    .footer-content-copyright {\n        width: 40px;\n        height: 40px;\n    }\n   \n}\n@media screen and (max-width: 340px) {\n    .footer-content {\n         font-size: 36px;\n    }\n    .footer-content-copyright-content {\n        padding: 0px 50px;\n    }\n    .footer-content-copyright {\n        width: 60px;\n        height: 60px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
